import styled from '@emotion/styled';
import { DEFAULT_THEME } from "../../constants/Theme";
import { ButtonLarge } from '../TypographyStyle';
export const TabHeader = styled.div `
	display: flex;
	flex-direction: row;
	background-color: ${(props) => props.bgColor};
`;
export const TabItem = styled.div `
	display: flex;
	flex-direction: row;
	column-gap: 8px;
	padding: ${(props) => (props.isSquared ? '8px 24px' : '14px 24px 12px 24px')};
	padding-bottom: ${(props) => props.isSquared ? '' : props.selected ? '12px' : '13px'};
	align-items: center;
	justify-content: center;
	width: ${(props) => (props.hasEqualSpacing ? '50%' : 'auto')};
	border-bottom-color: ${(props) => props.isSquared
    ? ''
    : props.selected
        ? props.selectedTextColor
        : DEFAULT_THEME.colorsV2.background.inactive};
	border-bottom-width: ${(props) => props.isSquared ? '' : props.selected ? '2px' : '1px'};
	border-bottom-style: ${(props) => (props.isSquared ? '' : 'solid')};
	border: ${(props) => props.isSquared
    ? props.selected
        ? `1px solid ${props.selectedTextColor}`
        : `1px solid ${DEFAULT_THEME.colorsV2.background.inactive}`
    : ''};
	flex-direction: row;
	cursor: pointer;
	min-width: ${(props) => (props.isSquared ? '120px' : '')};
	&:hover {
		background-color: rgba(0, 0, 0, 0.03);
	}
	background-color: ${(props) => props.isSquared
    ? props.selected
        ? `${DEFAULT_THEME.colorsV2.background.brandLight}`
        : ''
    : ''};
`;
export const TrailingNumberContainer = styled.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	justify-content: center;
	min-width: 20px;
	height: 20px;
	background: ${(props) => props.selected
    ? DEFAULT_THEME.colorsV2.background.inverseLight
    : DEFAULT_THEME.colorsV2.content.secondary};
	color: ${DEFAULT_THEME.colorsV2.content.primaryInverse};
	border-radius: 10px;
`;
export const TabItemText = styled(ButtonLarge) `
	color: ${(props) => props.selected ? props.selectedTextColor : props.textColor};
`;
export const EmptyTab = styled.div `
	flex-grow: 1;
	border-bottom: 1px solid ${DEFAULT_THEME.colorsV2.background.inactive};
`;
export const RightComponent = styled.div `
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${DEFAULT_THEME.colorsV2.background.inactive};
`;
//# sourceMappingURL=Tabs.styles.js.map